import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 10h16","key":"svg-0"}],["path",{"d":"M4 14h16","key":"svg-1"}],["path",{"d":"M9 18l3 3l3 -3","key":"svg-2"}],["path",{"d":"M9 6l3 -3l3 3","key":"svg-3"}]]

const IconMenuOrder = createReactComponent('outline', 'menu-order', 'MenuOrder', __iconNode);

export default IconMenuOrder;